const EXTERNAL_LINKS = {
    masonchain: "https://twitter.com/MasOnTheChain",
    banterlytics: "https://twitter.com/banterlytics",
    github: "https://github.com/masonchain/cyberkongz-data-dash",
    flipside: "https://www.flipsidecrypto.com/",
}

export default EXTERNAL_LINKS;